require('./accountAddDocumentationError.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
// @utility
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    PAGE_ERROR,
    PROC_CONTRACTS,
    recordLink,
    recordPath,
} = require('utilities/tagging');
const {
    getAccountNameProduct,
    getAccountNameText,
    getAccountPath,
} = require('utilities/accountAddDocumentationTaggingHelper');
// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const WizardError = require('components/commons/wizardError/wizardError');

class AccountAddDocumentationError extends React.Component {
    constructor(props) {
        super(props);

        this.handleRetry = this.handleRetry.bind(this);
        this.taggingRecordLink = this.taggingRecordLink.bind(this);
        this.handleErrorButtonClick = this.handleErrorButtonClick.bind(this);
    }

    componentDidMount() {
        const { immAccountAddDocumentation } = this.props;
        const subtype = immAccountAddDocumentation.get('subtype');
        recordPath(getAccountPath(subtype), '', PROC_CONTRACTS, PAGE_ERROR, getAccountNameProduct(subtype));
    }

    taggingRecordLink(documentName, tagName = '') {
        const { immAccountAddDocumentation } = this.props;
        let docType = '';

        switch (documentName) {
            case 'document':
                docType = 'documentacion de identidad';
                break;
            case 'daal':
                docType = 'documentacion de ingresos';
                break;
            case 'receipt':
                docType = 'documentacion de domicilio';
                break;
        }
        recordLink(getAccountPath(immAccountAddDocumentation.get('subtype')), docType, tagName);
    }

    handleErrorButtonClick() {
        const { history, immAccountAddDocumentation } = this.props;
        const subtype = immAccountAddDocumentation.get('subType');

        this.taggingRecordLink('', `volver a ${getAccountNameText(subtype)}`);

        if (!!immAccountAddDocumentation.get('alias')) {
            history.push(`/myprofile/accounts/${immAccountAddDocumentation.get('accountId')}/movements`);
        } else {
            history.push(`/myprofile/accounts`);
        }
    }

    handleRetry() {
        const {
            retryUploadDocumentation,
        } = this.props;

        retryUploadDocumentation();
        this.taggingRecordLink('', 'reintentar');
    }

    buildRetryButton() {
        return (
            <OKButton modifier="secondary" onClick={this.handleRetry}>
                <FormattedText value="common-retry" />
            </OKButton>
        );
    }

    buildBackButton() {
        const { immAccountAddDocumentation } = this.props;
        let button;

        if (!!immAccountAddDocumentation.get('alias')) {
            button = {
                label: formatText('accountUploadDocumentation-accountUploadDocumentation_backToAccount', [immAccountAddDocumentation.get('alias')]),
                url: `/myprofile/accounts/${immAccountAddDocumentation.get('accountId')}/movements`,
            };
        } else {
            button = {
                label: formatText('accountUploadDocumentation-accountUploadDocumentation_backToAccount', [formatText('accountUploadDocumentation-accountUploadDocumentation_accounts')]),
                url: `/myprofile/accounts`,
            };
        }

        return button;
    }

    renderError() {
        const { immVariables } = this.props;
        const title = formatText('accountUploadDocumentation-accountUploadDocumentation_errorTitle');
        const goBackButton = this.buildBackButton();
        const retryButton = this.buildRetryButton();

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackButton}
                    onMainButtonClick={this.handleErrorButtonClick}
                >
                    <p className="account-add-documentation-error__error-message">
                        <FormattedText
                            injectedStrings={[immVariables.getIn(['telefono', 'cliente'])]}
                            value="accountUploadDocumentation-accountUploadDocumentation_errorMessage"
                        />
                    </p>
                    {retryButton}
                </WizardError>
            </div>
        );
    }

    renderFileError(immFile, title) {
        let content;
        if (!!immFile.getIn(['front', 'file'])) {
            let errorLabel = (
                <FormattedText
                    className="account-add-documentation-error__list-error-item-text"
                    value="accountUploadDocumentation-accountUploadDocumentation_errorMessageSent"
                />
            );

            if (!!immFile.get('error')) {
                errorLabel = (
                    <FormattedText
                        className="account-add-documentation-error__list-error-item-text account-add-documentation-error__list-error-item-text--error"
                        value="accountUploadDocumentation-accountUploadDocumentation_errorMessageNotSent"
                    />
                );
            }
            content = (
                <div className="row account-add-documentation-error__list-error-item">
                    <div className="col-sm-9">
                        <FormattedText value={`accountUploadDocumentation-${title}`} />
                    </div>
                    <div className="col-sm-3">{errorLabel}</div>
                </div>
            );
        }

        return content;
    }

    renderErrorFileList() {
        const { immAccountAddDocumentation } = this.props;
        const immDaal = immAccountAddDocumentation.getIn(['files', 'daal']);
        const immDoc = immAccountAddDocumentation.getIn(['files', 'document']);
        const immReceipt = immAccountAddDocumentation.getIn(['files', 'receipt']);
        const title = formatText('accountUploadDocumentation-accountUploadDocumentation_errorTitle');
        const goBackButton = this.buildBackButton();
        const retryButton = this.buildRetryButton();
        let errorListContent = [];

        if (!!immDoc.getIn(['front', 'file'])) {
            const fileDoc = this.renderFileError(immDoc, 'accountUploadDocumentation_documentationIdentityTitle');

            if (!!fileDoc) {
                errorListContent.push(fileDoc);
            }
        }

        if (!!immDaal.getIn(['front', 'file'])) {
            const fileDaal = this.renderFileError(immDaal, 'accountUploadDocumentation_documentationEarnTitle');

            if (!!fileDaal) {
                errorListContent.push(fileDaal);
            }
        }

        if (!!immReceipt.getIn(['front', 'file'])) {
            const fileReceipt = this.renderFileError(immReceipt, 'accountUploadDocumentation_documentationAddressTitle');

            if (!!fileReceipt) {
                errorListContent.push(fileReceipt);
            }
        }

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackButton}
                    onMainButtonClick={this.handleErrorButtonClick}
                >
                    <div className="account-add-documentation-error__error-message">
                        <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_errorFilesMessage" />
                    </div>
                    <div className="account-add-documentation-error__error-message">
                        {errorListContent}
                    </div>
                    {retryButton}
                </WizardError>
            </div>
        );
    }

    render() {
        const { immAccountAddDocumentation } = this.props;
        const immDaal = immAccountAddDocumentation.getIn(['files', 'daal']);
        const immDoc = immAccountAddDocumentation.getIn(['files', 'document']);
        const immReceipt = immAccountAddDocumentation.getIn(['files', 'receipt']);
        let totalFiles = 0;
        let totalErrors = 0;
        let content;

        if (!!immDaal.getIn(['front', 'file'])) {
            totalFiles++;
            if (!!immDaal.get('error')) {
                totalErrors++;
            }
        }

        if (!!immDoc.getIn(['front', 'file'])) {
            totalFiles++;
            if (!!immDoc.get('error')) {
                totalErrors++;
            }
        }

        if (!!immReceipt.getIn(['front', 'file'])) {
            totalFiles++;
            if (!!immReceipt.get('error')) {
                totalErrors++;
            }
        }


        if (immAccountAddDocumentation.get('errorTramitationFlags') || totalFiles === totalErrors) {
            content = this.renderError();
        } else {
            content = this.renderErrorFileList();
        }

        return content;
    }
}

AccountAddDocumentationError.propTypes = {
    history: PropTypes.object.isRequired,
    immAccountAddDocumentation: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    retryUploadDocumentation: PropTypes.func.isRequired,
};

module.exports = withRouter(AccountAddDocumentationError);
